import { render, staticRenderFns } from "./ContactPanel.vue?vue&type=template&id=0c7a8ba7&"
import script from "./ContactPanel.vue?vue&type=script&lang=ts&"
export * from "./ContactPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports